/* jshint esversion: 6, -W097 */
/* globals require */
'use strict';


function defaultCheckboxesFilterDirective() {

    return {
        // must be an element (can not be used as an attribute or ...)
        restrict: 'E',
        scope: {
            code: '=',
            isFullWidth: '=',
            options: '='
        },
        controllerAs: 'vm',
        bindToController: true,
        controller: defaultCheckboxesFilter,
        template: require('./checkboxesFilterView.html')
    };
}

defaultCheckboxesFilter.$inject = [
    'FiltersService',
    'UtilService'
];
function defaultCheckboxesFilter(
    FiltersService,
    UtilService
) {

    this.$onInit = () => {
        const vm = this;

        let resetDefaultValues = [];
        vm.shownOptions = vm.options.values;

        if (vm.code in FiltersService.initialFiltersData) {
            prepopulateFilter(vm.code);
        }

        vm.isReady = () => {
            return !FiltersService.lockFilters;
        };

        FiltersService.filtersOutputCallbacks.push({
            'filter_output': filterOutput
        });

        populateUnselectedFilterDefault();

        FiltersService.filtersResetCallbacks.push({
            filterKey: vm.code,
            callback: filterReset
        });

        /**
         * Manages the toggle automatic off and on functionality
         * between the model year and latest model filters
         *
         * @param urlValue {string} url value of the changed checkbox
         */
        vm.checkboxChanged = function(urlValue) {
            FiltersService.trackProductFiltersEngaged(filterOutput());
            FiltersService.checkFilterAutoToggles(urlValue);
            FiltersService.getResultsOnChange();
        };

        /**
         * Outputs the filter's user inputs in form of a single-level key values dictionary
         *
         * @returns {'filter_code', 'filter_value'}
         */
        function filterOutput() {
            let output = {};
            output[vm.options.url_value] = [];

            vm.options.values.forEach((value) => {
                if (value.is_checked) {
                    output[vm.options.url_value].push(value.url_value);
                }
            });

            if (output[vm.options.url_value].length === 0) {
                output = setUnselectedFilterDefaultValue(output);
            }
            output = checkFilterResetStatus(output);
            return output;
        }

        /**
         * Assures that if the default filter is unselected,
         * the unselected value of that particular default filter will be applied to make sure it
         * is not selected anymore (since it will be selected by default)
         *
         * @param output
         * @return {Object} the updated output value of the applicant filters
         */
        function setUnselectedFilterDefaultValue(output) {
            output[vm.options.url_value] = null;
            for (let i in FiltersService.defaultFilterSettings) {
                const defaultFilterSetting = FiltersService.defaultFilterSettings[i];
                const isCurrentFilter = vm.options.url_value === defaultFilterSetting.urlValue;
                if (isCurrentFilter) {
                    output[vm.options.url_value] = defaultFilterSetting.unselectedValue;
                }
            }

            return output
        }

        /**
         * Populates the unselected values, so the default filters are unselected if all filters are reset
         *
         */
        function populateUnselectedFilterDefault() {
            for (const defaultFilterSetting of FiltersService.defaultFilterSettings) {
                FiltersService.unselectedDefaultFilters[defaultFilterSetting.urlValue] = defaultFilterSetting.unselectedValue;
            }
        }

        /**
         * Assures that if a default filter is reset, the unselected value of that particular default
         * filter will be applied to make sure it is not selected anymore
         *
         * @param output
         * @return {Object} the updated output value of the applicant filters
         */
        function checkFilterResetStatus(output) {
            for (const defaultFilterSetting of FiltersService.defaultFilterSettings) {
                const isCurrentFilter = vm.options.url_value === defaultFilterSetting.urlValue;
                if (isCurrentFilter && resetDefaultValues.includes(defaultFilterSetting.code)) {
                    output[vm.options.url_value] = defaultFilterSetting.unselectedValue;
                    resetDefaultValues = resetDefaultValues.filter(function(item) {
                        return item !== defaultFilterSetting.code
                    });
                }
            }

            return output;
        }

        /**
         * Clears out a default filter
         * @param valueToRemove
         */
        function filterReset(valueToRemove) {
            for (const defaultFilterSetting of FiltersService.defaultFilterSettings) {
                if (vm.code === defaultFilterSetting.code) {
                    resetDefaultValues.push(vm.code);
                    break;
                }
            }

            vm.options.values.forEach((value) => {
                if (valueToRemove === null || value.display_name === valueToRemove) {
                    value.is_checked = false;
                }
            });
        }

        /**
         * Pre-populates the filter
         *
         */
        function prepopulateFilter (code) {
            let preSelectedChoices = FiltersService.initialFiltersData[code];

            vm.options.values.forEach((value) => {
                value.is_checked = false;
            });

            if (!Array.isArray(preSelectedChoices)) {
                preSelectedChoices = [preSelectedChoices];
            }
            preSelectedChoices = UtilService.forceArray(preSelectedChoices);

            preSelectedChoices.forEach((selectedChoice) => {
                vm.options.values.forEach((value) => {
                    if (value.display_name.toString().toLowerCase() === selectedChoice.toLowerCase()) {
                        value.is_checked = true;
                    }
                });
            });
        }

    };

}

module.exports = defaultCheckboxesFilterDirective;